import { TextInput } from 'react-native';
import { IconName } from '../Icon';

export type SortDirection = 'asc' | 'desc';

export type SortState = {
    columnKey: string;
    direction: SortDirection;
};

export type ColumnAlignment = 'left' | 'right' | 'center';

export type SortValue = string | number | null | Date;

export type SearchValue = string | number | null;

export type TableActionGroup<TDataElement> = {
    title: string;
    testID?: string;
    icon: IconName;
    actions: TableAction<TDataElement>[];
};

export type ColumnConfig<TDataElement> = {
    columnKey: string;
    label: string;
    getSortValue?: (dataElement: TDataElement) => SortValue;
    getDiscreetValue?: (dataElement: TDataElement) => string | null | string[];
    renderMenuItem?: (dataElement: TDataElement) => React.ReactNode;
    render: (dataElement: TDataElement) => React.ReactNode | null | string | number;
    getContentKey?: (dataElement: TDataElement) => string;
    getSearchValue?: (dataElement: TDataElement) => SearchValue;
    align?: ColumnAlignment;
    hideOnMobile?: boolean;
};

export type TableConfig<TDataElement> = {
    columns: ColumnConfig<TDataElement>[];
    getRowKey: (dataElement: TDataElement) => string;
};

export type ColumnFilterState = {
    selectedDiscreetValues?: string[];
};

export type RichTableState = {
    searchValue: string;
    columnFilters: Record<string, ColumnFilterState | undefined>;
    sortState: SortState | undefined;
    selectedRowKeys: string[];
};

export type TableAction<TDataElement> = {
    title: string;
    onPress: (dataElements: TDataElement[]) => void;
    shouldShow: (dataElements: TDataElement[]) => boolean;
    shouldDisable?: (dataElements: TDataElement[]) => boolean;
    icon: IconName;
    testID?: string;
    renderAfter?: (dataElements: TDataElement[]) => React.ReactNode;
};

export type TableActionOrGroup<TDataElement> = TableAction<TDataElement> | TableActionGroup<TDataElement>;

export const isTableActionGroup = <TDataElement>(
    actionOrGroup: TableActionOrGroup<TDataElement>,
): actionOrGroup is TableActionGroup<TDataElement> => {
    return (actionOrGroup as TableActionGroup<TDataElement>).actions !== undefined;
};

export type GridRefs = (TextInput | null)[][];

export type SetInputRefArgs = {
    rowIndex: number;
    columnIndex: number;
    ref: TextInput | null;
};

export type SelectedCategory = {
    count: number;
    label: string;
};

export type SelectedCategories = SelectedCategory[];
